<template>
    <div id="theater" class="section_theather">
        <div class="grid-container">
            <section class="section_theather--main grid-x grid-padding-x align-center">
                <h2 class="section_theather--title">THEATHER</h2>
                <img src="/netemosametemo/static/img/cat_img02.png" alt="Cat" class="section_theather--cat">
                <article class="theather_article cell small-12 medium-10" v-for="(area,index) in theatersData" :key="index">
                    <h3 class="theather_article--area_title">{{area.theaters_areas}}</h3>
                    <table class="unstriped theather_article--info">
                        <thead class="theather_article--info--thead">
                            <tr>
                                <th>劇場名</th>
                                <th>TEL</th>
                                <th>公開日</th>
                            </tr>
                        </thead>
                        <tbody v-for="theater in area.theaters" :key="theater.id">
                            <tr v-if="theater.isNewPref" class="theather_article--info--area">
                                <td colspan="3">{{theater.theater_city}}</td>
                            </tr>
                            <theater-item :theater="theater"></theater-item>
                        </tbody>
                    </table>
                </article>
            </section>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from '@/services/axios'
import TheatersItem from '@/components/TheatersItem'

Vue.component('theater-item', TheatersItem)

export default {
    name: 'theather',
    data () {
        return {
            theatersData: [],
            currentPref: ''
        }
    },

    created: function () {
        this.fetchData()
    },

    methods: {
        fetchData: function () {
            axios.get('pages?slug=theaters')
                .then(response => {
                    this.theatersData = response.data[0].acf.theaters_list
                    this.sortPrefectures()
                })
        },

        sortPrefectures: function () {
            this.theatersData.forEach(function (item) {
                for (let i = 0; i < item.theaters.length; i++) {
                    if (i > 0) {
                        if (item.theaters[i].theater_city !== item.theaters[i - 1].theater_city) {
                            item.theaters[i].isNewPref = true
                        }
                    } else {
                        item.theaters[i].isNewPref = true
                    }
                }
            })
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Theaters.vue